import React, { useEffect, useState } from "react";
import Navbar from "../components/sections/Navbar";
import Hero from "../components/sections/Hero";
import LeConstat from "../components/sections/LeConstat";
import LeConcept from "../components/sections/LeConcept";
import ImageBand from "../components/sections/ImageBand";
import NosServices from "../components/sections/NosServices";
import Tracabilite from "../components/sections/Tracabilite";
import NosPromesses from "../components/sections/NosPromesses";
import LeReseau from "../components/sections/LeReseau";
import DevenirDiallo from "../components/sections/DevenirDiallo";
import Footer from "../components/sections/Footer";
import IntroSplash from "../components/sections/IntroSplash";

export default function Home() {
  const [entered, setEntered] = useState(false);

  // Lock scroll while the intro splash is visible.
  useEffect(() => {
    if (!entered) {
      document.body.style.overflow = "hidden";
      window.__lenis?.stop?.();
    } else {
      document.body.style.overflow = "";
      window.__lenis?.start?.();
      window.__lenis?.scrollTo?.(0, { immediate: true });
      window.scrollTo(0, 0);
    }
    return () => {
      document.body.style.overflow = "";
    };
  }, [entered]);

  return (
    <div className="bg-white">
      {!entered && <IntroSplash onEnter={() => setEntered(true)} />}

      <Navbar />
      <main>
        <Hero />
        <LeConstat />
        <LeConcept />
        <ImageBand />
        <NosServices />
        <Tracabilite />
        <NosPromesses />
        <LeReseau />
        <DevenirDiallo />
      </main>
      <Footer />
    </div>
  );
}
